import { AHIcon, AHText, Box } from "arkh";
import React, { useCallback } from "react";
import { TaskTypeIcon, TaskTypeIconSize } from "../../../../types/TaskTypeIcon";
import { Pressable, TextInput } from "react-native";
import { TitleInput } from "./TitleInput";
import { TopicAndDisableableIndicator } from "../TopicAndDisableableIndicator";

type Props = {
  orgTopic: {
    id: string;
    name: string;
    isPrivate: boolean;
  } | null;
  canBeDisabled: boolean;
  taskId: string;
  title: string;
  collapsedInstruction: string;
  taskType: "CHECK" | "OPTIONS" | "NUMBER" | "TEXT";
  selectedSectionTask: boolean;
  hasImages: boolean;

  onChangeTitle(title: string): void;
  onPressTaskType(taskId: string): void;
  onFocus(): void;
  ref: React.RefObject<TextInput | null>;
};
export const Body = ({
  orgTopic,
  canBeDisabled,
  taskId,
  selectedSectionTask,
  title,
  taskType,
  collapsedInstruction,
  hasImages,
  onPressTaskType,
  onChangeTitle,
  onFocus,

  ref,
}: Props) => {
  const _onPressTaskType = useCallback(() => {
    onPressTaskType(taskId);
  }, [onPressTaskType, taskId]);

  return (
    <Box style={{ flex: 1 }}>
      <Box
        style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
        spaceRight="medium"
      >
        <TitleInput
          ref={ref}
          title={title}
          setTitle={onChangeTitle}
          onFocus={onFocus}
        />
        <TopicAndDisableableIndicator
          orgCanBeDisabled={canBeDisabled}
          orgTopic={orgTopic}
        />
        <Pressable {...{ tabIndex: -1 }} onPress={_onPressTaskType}>
          <TaskTypeIcon
            size={TaskTypeIconSize.XSMALL}
            type={
              taskType === "CHECK"
                ? {
                    __typename: "TaskCheck",
                    sentiments: ["POSITIVE" as const],
                  }
                : taskType === "OPTIONS"
                  ? {
                      __typename: "TaskCheck",
                      sentiments: ["POSITIVE" as const, "NEGATIVE" as const],
                    }
                  : taskType === "NUMBER"
                    ? { __typename: "TaskNumber", unit: "CUSTOM" }
                    : { __typename: "TaskText" }
            }
          />
        </Pressable>
      </Box>
      {!selectedSectionTask && collapsedInstruction.length > 0 ? (
        <Box spaceHorizontal="small" style={{ flex: 1 }}>
          <AHText
            numberOfLines={1}
            ellipsizeMode="tail"
            spaceTop="xsmall"
            spaceBottom="small"
            spaceHorizontal="small"
            style={{ flex: 1 }}
          >
            {collapsedInstruction}
          </AHText>
        </Box>
      ) : null}
      {!selectedSectionTask && hasImages ? (
        <AHIcon
          type="image"
          spaceTop="xsmall"
          color="washedText"
          spaceHorizontal="medium"
        />
      ) : null}
    </Box>
  );
};
